import React, { FC, useEffect, useRef, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { fetchData } from 'src/fetch/stepA';
import { errorModalViewStore, loadingModalViewStore } from 'src/store/modal';
// import { userInfoData } from 'src/store/userInfo';
import { getMemberInfo } from 'src/utils/common';
import { myInfoDataStore } from 'src/store/myInfo';
import { familyDataStore } from 'src/store/familyInfo';
import Template from './template';

interface Props {
  num: number;
}

const StepA: FC<Props> = ({ num }) => {
  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const loadingState = loadingModalViewStore((state: any) => state.set);
  const myInfoDataState = myInfoDataStore((state: any) => state.init);
  const familyInfoDataState = familyDataStore((state: any) => state.bind);
  const familyInfoDataParam = familyDataStore((state: any) => state.param);
  const myInfoDataParam = familyDataStore((state: any) => state.param);

  const param: any = getMemberInfo();

  useEffect(() => {
    fetchData(
      param,
      errorModalState,
      myInfoDataState,
      familyInfoDataState,
      loadingState,
      queryClient
    );
  }, [familyInfoDataParam, myInfoDataParam]);

  return (
    <div className="_step_layout">
      <Template num={num} />
    </div>
  );
};

export default StepA;
